<template>
  <div class="form-group" :class="{'input-box': showInputBox}">
    <i
      v-if="addEmailNotification"
      class="glyphicon glyphicon-envelope"
      v-tooltip="'Email might be generated'"
      title="Email might be generated"
    >
    </i>

    <span class="form-group">
      <label :class="{ 'text-danger': hasErrors(getFieldName) }"> {{ label }} </label>
      <comments v-if="addComment" :field-name="getCommentfieldName" :model-name="modelName"></comments>
      <br />
      <small class="form-text text-muted" v-if="subtext">
        {{ subtext }}
      </small>
    </span>

    <input
      type="date"
      class="form-control"
      v-model.lazy="inputVal"
      :name="getFieldName"
      :data-vv-as="label"
      :min="getMinDate.format('YYYY-MM-DD')"
      :max="maxDate.format('YYYY-MM-DD')"
      v-validate.immediate="getValidation"
      v-bind="$attrs"
      :disabled="getIsReadOnly"
    />

    <span v-show="errors.has(getFieldName)" class="text-danger">{{ errors.first(getFieldName) }}</span>

    <div v-show="hasErrors(getFieldName)">
      <span
        v-for="(error, index) in errorsFor(getFieldName)"
        class="text-danger"
        :key="`error_${getFieldName}_${index}`"
      >
        {{ error }}
      </span>
    </div>
  </div>
</template>

<script>
import CustomInputMixin from './CustomInputMixin'

export default {
  name: 'DateInput',
  mixins: [CustomInputMixin],
  props: ['minDate'],
  computed: {
    getValidation() {
      return `date_format:yyyy-MM-dd|date_between:${this.getMinDate.format('YYYY-MM-DD')},${this.maxDate.format(
        'YYYY-MM-DD'
      )},'[]'`
    },
    getMinDate() {
      return this.minDate
        ? this.$moment(this.minDate)
        : this.$moment(this.getFieldValue('consult_opened_date', 'Misc'), 'YYYY-MM-DD')
    },
    maxDate() {
      return this.$moment(this.getMinDate).add(18, 'months')
    },
  },
}
</script>

<style scoped>
i {
  margin-right: 0.5em;
}
</style>
